<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size * 13 / 21"
    viewBox="0 0 21 13"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M18.968 0H6.323a1.265 1.265 0 0 0 0 2.53h12.645a1.265 1.265 0 0 0 0-2.53z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M18.968 5.058H6.323a1.265 1.265 0 0 0 0 2.53h12.645a1.265 1.265 0 0 0 0-2.53z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M18.968 10.117H6.323a1.265 1.265 0 0 0 0 2.529h12.645a1.265 1.265 0 0 0 0-2.53z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M0 1.265a1.265 1.265 0 1 1 2.53 0 1.265 1.265 0 0 1-2.53 0z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M0 6.323a1.265 1.265 0 1 1 2.53 0 1.265 1.265 0 0 1-2.53 0z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M0 11.381a1.265 1.265 0 1 1 2.53 0 1.265 1.265 0 0 1-2.53 0z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#F6F5F8',
    },
    size: {
      type: Number,
      default: 21,
    },
  },
};
</script>
